import { useContext, useMemo } from 'react';
import { Chip } from '@mui/material';
import { AppContext } from '../AppContext';
import { chipColors } from '../../lib/contrast';

type FileFormat = {
    id: string;
    label: string;
    color: string;
};

type Props = {
    format: string;
};

/**
 * Chip file format: png, jpg, text, etc ...
 */
export function SttChipFileFormat({ format }: Props): React.ReactElement {
    const cxt = useContext(AppContext)!;

    const fileFormat = useMemo((): FileFormat | undefined => {
        if (!format || !cxt?.constants?.fileFormats) return undefined;

        return cxt.constants.fileFormats.find(
            (e: FileFormat) => e.id === format,
        );
    }, [format, cxt?.constants?.fileFormats]);

    if (!format || !fileFormat) {
        return <></>;
    }

    return (
        <Chip
            size="small"
            label={fileFormat.label}
            sx={{
                ...chipColors(fileFormat.color),
            }}
        />
    );
}
